export default "__VITE_ASSET__DZ0i9s7P__"